import { z } from 'zod';
export const leadStatusSchema = z.enum([
    'NEW',
    'CONTACTED',
    'QUALIFIED',
    'REJECTED',
]);
/**
 * One question/answer pair captured from the form. `key` is the form field
 * name, `label` is the question text shown at submission time (preserved
 * so admin views show the right wording even if the live form changes),
 * and `value` is the user's answer.
 */
export const customFieldSchema = z.object({
    key: z.string().min(1).max(80),
    label: z.string().min(1).max(200),
    value: z.string().max(2000),
});
/**
 * Meta Conversions API context, sent by the browser alongside the lead.
 *
 * Present ONLY when the visitor accepted the cookie banner — the client
 * omits this block entirely otherwise, and the server then skips the
 * server-side conversion. `eventId` is generated before submitting and
 * reused for the browser pixel's `Lead` event, so Meta deduplicates the
 * two into one conversion instead of counting it twice.
 */
export const leadMetaSchema = z.object({
    /** Shared dedup key between the browser event and the server event. */
    eventId: z.string().min(1).max(100),
    /** Meta's `_fbp` browser cookie, if the pixel has set one. */
    fbp: z.string().max(200).optional(),
    /** Meta's `_fbc` click cookie — present when the visit came from an ad. */
    fbc: z.string().max(500).optional(),
    /** The page the form was submitted from. */
    sourceUrl: z.string().url().max(500).optional(),
});
export const leadCreateSchema = z.object({
    name: z.string().min(1).max(120).trim(),
    email: z.string().email().toLowerCase().trim(),
    phone: z.string().max(40).trim().optional().or(z.literal('').transform(() => undefined)),
    description: z.string().min(1).max(5000).trim(),
    customFields: z.array(customFieldSchema).max(50).default([]),
    // Hidden honeypot field — real users never see or fill it. The server
    // checks it before writing to the DB; bots that fill it get a 201 OK
    // but their submission is dropped silently.
    website: z.string().max(200).optional(),
    // Optional — only sent once the visitor has consented to tracking.
    meta: leadMetaSchema.optional(),
});
export const leadUpdateSchema = z.object({
    status: leadStatusSchema.optional(),
    isRead: z.boolean().optional(),
    notes: z.string().max(5000).nullable().optional(),
});
export const leadSchema = z.object({
    id: z.string(),
    name: z.string(),
    email: z.string().email(),
    phone: z.string().nullable(),
    description: z.string(),
    customFields: z.array(customFieldSchema),
    status: leadStatusSchema,
    isRead: z.boolean(),
    notes: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=lead.js.map